import type {
  ChannelCourseResource,
  ChannelExpandedCommon,
} from '../../../api/channel';

import {isMeCoachForEntity} from '../isMeCoachForEntity';

export const shouldArchivedChannelBeShown = (
  channel: ChannelExpandedCommon,
) => {
  const isMeProgramCoach = isMeCoachForEntity(
    (channel.resource as ChannelCourseResource)?.program,
  );
  const isProgramDeleted = Boolean(
    (channel.resource as ChannelCourseResource)?.program?.deleted,
  );
  const isCourseDeleted = Boolean(
    (channel.resource as ChannelCourseResource)?.deleted,
  );

  const shouldChannelBeIgnored =
    isMeProgramCoach && (isProgramDeleted || isCourseDeleted);

  return !shouldChannelBeIgnored;
};
